/**
 * In-memory playground authorization only.
 * Never writes tokens to localStorage / sessionStorage / IndexedDB.
 * Cleared on logout via `prime-playground-clear-auth` event.
 */

const state = {
  bearerToken: '',
  apiKey: '',
  gatewayApiKey: '',
  authMode: 'session', // session | bearer | apiKey
  listeners: new Set(),
};

function notify() {
  state.listeners.forEach((fn) => {
    try { fn(getPublicState()); } catch { /* ignore */ }
  });
}

export function getPublicState() {
  return {
    authMode: state.authMode,
    hasBearer: Boolean(state.bearerToken),
    hasApiKey: Boolean(state.apiKey),
    hasGatewayApiKey: Boolean(state.gatewayApiKey),
    // Never expose raw token values — only boolean presence flags
  };
}

export function getSecretsForExecute() {
  return {
    authMode: state.authMode,
    bearerToken: state.bearerToken,
    apiKey: state.apiKey,
    gatewayApiKey: state.gatewayApiKey,
  };
}

export function setAuthMode(mode) {
  state.authMode = mode;
  notify();
}

export function setBearerToken(token) {
  state.bearerToken = String(token || '').replace(/^Bearer\s+/i, '').trim();
  notify();
}

export function setApiKey(key) {
  state.apiKey = String(key || '').trim();
  notify();
}

export function setGatewayApiKey(key) {
  state.gatewayApiKey = String(key || '').trim();
  notify();
}

export function clearPlaygroundAuth() {
  state.bearerToken = '';
  state.apiKey = '';
  state.gatewayApiKey = '';
  state.authMode = 'session';
  notify();
}

export function subscribePlaygroundAuth(fn) {
  state.listeners.add(fn);
  return () => state.listeners.delete(fn);
}

if (typeof window !== 'undefined') {
  window.addEventListener('prime-playground-clear-auth', () => {
    clearPlaygroundAuth();
  });
}
